<highcharts-chart
  [Highcharts]="highcharts"
  [options]="solidGaugeChartOptions"
  [style.height]="height"
  style="width: 100%; display: block"
>
</highcharts-chart>
